<template>
  <BaseLayout>
    <BaseDashboard :is-loading="false">
      <div class="h-100 overflow-x-auto overflow-y-hidden">
        <b-row>
          <b-col>
            <div
              class="page-header bg-secondary m-0 p-3 border-bottom"
              slot="header"
            >
              <p class="page-title">
                Account Settings
              </p>
              <div class="page-options d-flex">
                <b-button
                  data-test="add-template"
                  variant="primary"
                  size="md"
                  :disabled="!isDirty"
                  @click="save"
                >
                  Save
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </BaseDashboard>
  </BaseLayout>
</template>

<script>
import {
  mapActions,
  mapMutations,
  mapState,
} from 'vuex';
import * as types from '@/store/types';
import * as accountTypes from '@/modules/account/store/types';

export default {
  name: 'AccountSettings',
  data() {
    return {
    };
  },
  computed: {
    ...mapState('account', {
      accountId: 'id',
      accountProperties: 'properties',
    }),
    isDirty() {
      return false;
    },
  },
  methods: {
    ...mapActions('account', [
      accountTypes.FETCH_ACCOUNT,
      accountTypes.UPDATE_ACCOUNT,
    ]),
    ...mapMutations([
      types.SET_GLOBAL_MESSAGE,
    ]),
    async save() {
      await this.UPDATE_ACCOUNT({
        id: this.accountId,
        properties: {},
      });
      this.SET_GLOBAL_MESSAGE({
        message: 'Account settings updated',
        type: 'info',
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    const h = this.$createElement;
    if (!this.isDirty) return next();
    this.$bvModal.msgBoxConfirm(h('p', [
      'You have unsaved changes!',
      h('br'),
      'Press "Proceed" to continue without saving, or "Cancel" to go back and review your changes',
    ]), {
      title: 'Warning',
      size: 'sm',
      buttonSize: 'sm',
      okTitle: 'Proceed',
      okVariant: 'danger',
      cancelTitle: 'Cancel',
      cancelVariant: 'tertiary',
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true,
    })
      .then((value) => {
        if (!value) return next(false);
        return next();
      })
      .catch(() => next(false));
  },
  async created() {
    await this.FETCH_ACCOUNT();
  },
};
</script>
